import { getFromStorage, persistInStorage } from "../../util/outfitMabHelpers";

export const outfitMabActions = {
  HYDRATE_OUTFIT_MAB: "HYDRATE_OUTFIT_MAB",
  SET_OUTFIT_MABS: "SET_OUTFIT_MABS",
  CLEAR_OUTFIT_MABS: "CLEAR_OUTFIT_MABS",
};

export function hydrateOutfitMab() {
  const openedMab = getFromStorage();
  return (dispatch) => {
    dispatch({
      type: outfitMabActions.HYDRATE_OUTFIT_MAB,
      payload: openedMab,
    });
  };
}

export function toggleOutfitMab(mab, isVisible) {
  return (dispatch, getState) => {
    const { rootReducer = {} } = getState();
    let newOutfits = [...(rootReducer?.outfittingMab?.openOutfits ?? [])];
    if (isVisible === true) {
      newOutfits.push(mab);
    } else {
      newOutfits = newOutfits.filter((item) => item !== mab);
    }
    persistInStorage(newOutfits);
    dispatch({
      type: outfitMabActions.SET_OUTFIT_MABS,
      payload: newOutfits,
    });
  };
}

export function clearOutfitMabs() {
  return (dispatch) => {
    persistInStorage([]);
    dispatch({
      type: outfitMabActions.CLEAR_OUTFIT_MABS,
    });
  };
}
